<template>
    <div>

    </div>
</template>

<script>
    import {getUsName} from '@/utils/auth'

    export default {
        name: "LoginSingle",
        data() {
            return {
                form: {
                    account: '',
                    pwd: ''
                }
            }
        },
        methods:{
            loginSingle(){
                this.form = {
                    account: $PARAMS.user.username,
                    pwd: $PARAMS.user.password
                }
                if ($PARAMS.isLoginEncrypt) {
                    this.$store.dispatch('LoginAes', this.form).then(() => {
                        this.login2Home();
                    }).catch(() => {
                    })
                } else {
                    this.$store.dispatch('Login', this.form).then(() => {
                        this.login2Home();
                    }).catch(() => {
                    })
                }
            },
            login2Home() {
                this.$Message.success('欢迎您,' + getUsName() + '!');
                this.$addStorageEvent(2, "isLogin", "true");
                this.$router.push("/index");
            }
        },
        mounted() {
            this.loginSingle();
        }
    }
</script>

<style scoped>

</style>